export default "__VITE_PUBLIC_ASSET__60c05c33__"